/**
 * Utility functions for integrating charts with AskAI
 */

export interface ChartAskAIEvent {
    chartId: number;
    chartTitle?: string;
    chartType?: string;
    message?: string;
}

/**
 * Opens the AskAI chatbot with chart context
 * @param chartId - The ID of the chart to analyze
 * @param chartTitle - Optional title of the chart
 * @param chartType - Optional type of the chart
 * @param message - Optional initial message (defaults to chart explanation request)
 */
export const openAskAIWithChart = (
    chartId: number, 
    chartTitle?: string, 
    chartType?: string,
    message?: string
) => {
    const defaultMessage = `Please analyze chart ${chartId}${chartTitle ? ` (${chartTitle})` : ''}. Provide insights about the data patterns, trends, and key findings.`;
    
    const eventData: ChartAskAIEvent = {
        chartId,
        chartTitle,
        chartType,
        message: message || defaultMessage
    };

    // Dispatch custom event to open chatbot with chart context
    window.dispatchEvent(new CustomEvent('openAskAIWithChart', { 
        detail: eventData 
    }));
};

/**
 * Creates a chart visualization message for the chatbot
 * @param chartId - The ID of the chart
 * @param chartTitle - Optional title of the chart
 * @returns Formatted message with chart reference
 */
export const createChartMessage = (chartId: number, chartTitle?: string): string => {
    return `📊 **Chart Analysis Request**\n\nChart ID: ${chartId}${chartTitle ? `\nTitle: ${chartTitle}` : ''}\n\nPlease analyze this chart and provide insights about:\n- Key trends and patterns\n- Notable data points\n- Business implications\n- Recommendations based on the data`;
};
